import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="case-consideration"
export default class extends Controller {
  static targets = ["toggle", "input", "state"]

  connect() {
    // On connect, set initial state from checkbox
    if (this.hasStateTarget && this.stateTarget.checked) {
      this.toggleTarget.classList.add("active")
      this.inputTarget.classList.add("text-uppercase")
    }
  }

  toggle() {
    this.toggleTarget.classList.toggle("active")

    if (this.hasStateTarget) {
      this.stateTarget.checked = this.toggleTarget.classList.contains("active")
    }

    this.inputTarget.classList.toggle("text-uppercase")
  }
}
